import { connect } from 'react-redux'

import AreaCard from '../../components/areas/area-card'

function mapStateToProps (state, ownProps) {
  const area = state.areas[ownProps.areaId]

  if (!area) return {}

  const latestHistory = state.areaHistories[area.latestHistory]
  const technician = state.users[(latestHistory || {}).technician]

  return {
    area,
    latestHistory,
    technician
  }
}

export default connect(mapStateToProps)(AreaCard)



// WEBPACK FOOTER //
// ./src/containers/areas/area-card-container.js